import { useQuery } from 'react-query';

import { cacheKeys } from 'config';
import { risksClient } from 'clients/risks/risksClient';

export type Params = {
  id: string;
};

type Options = {
  enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useRisk = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data: risk } = {}, status, error } = useQuery(
    [cacheKeys.risks.getRisk, params],
    () => risksClient.getRisk(params.id),
    {
      enabled: options.enabled,
    },
  );

  return {
    status,
    error,
    risk,
  };
};
